import { useTranslation } from 'react-i18next'
import { Item, ItemLabel, ItemValue } from '../_styles'
import { useProduct } from '../../../_methods'
import {
  getWineGeoIndicationString,
  getWineNationalGITypeString,
} from 'utils/wine'

const GeoIndication = () => {
  const { t } = useTranslation()

  const product = useProduct()
  const wine = product?.wine
  const geoIndications = getWineGeoIndicationString(wine)
  const nationalGIType = getWineNationalGITypeString(wine)

  const value = [geoIndications, nationalGIType].filter(Boolean).join(' ')

  if (!value) return null

  return (
    <Item>
      <ItemLabel>{t('wine.view.geoIndication')}</ItemLabel>
      <ItemValue>{value}</ItemValue>
    </Item>
  )
}

export default GeoIndication
